module.exports = __webpack_public_path__ + "images/embed/reports_multi_select.gif";